import { render, staticRenderFns } from "./RegionInput.vue?vue&type=template&id=6e0f4c86"
import script from "./RegionInput.vue?vue&type=script&lang=ts"
export * from "./RegionInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e0f4c86')) {
      api.createRecord('6e0f4c86', component.options)
    } else {
      api.reload('6e0f4c86', component.options)
    }
    module.hot.accept("./RegionInput.vue?vue&type=template&id=6e0f4c86", function () {
      api.rerender('6e0f4c86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/RegionInput.vue"
export default component.exports